import PropTypes from 'prop-types';
import React from 'react';
import CheckmarkTextButton from './CheckmarkTextButton';

const TRANSITIONED_PROPERTY = 'transform';

const PopupQuestion = (props) => {
    const hiddenClass = () => `${(props.isHidden ? '' : ' question-active')}`;
    const isLastResponse = (responseIndex) => responseIndex === props.possibleResponses.length - 1;
    const onTransitionEnd = (transition) => {
        if (transition.propertyName === TRANSITIONED_PROPERTY && props.isHidden) {
            props.onHide();
        }
    };
    return (
        <div
            className={`fluency-question${hiddenClass()}`}
            onTransitionEnd={onTransitionEnd}>
            <p>{props.question}</p>
            <div className="fluency-answers">
                {props.possibleResponses.map((response, i) => [
                    <CheckmarkTextButton
                        onClick={props.onResponseSelected}
                        isSelected={i === props.selectedResponse}
                        text={response.text}
                        index={i}
                        key={response.id}
                    />,
                    isLastResponse(i) ? null : <div className="fluency-answer-spacer" />,
                ])}
            </div>
        </div>
    );
};

/* eslint-disable react/no-unused-prop-types */
PopupQuestion.propTypes = {
    question: PropTypes.string.isRequired,
    possibleResponses: PropTypes.arrayOf(PropTypes.object).isRequired,
    isHidden: PropTypes.bool,
    onResponseSelected: PropTypes.func,
    onHide: PropTypes.func,
    selectedResponse: PropTypes.number,
};
/* eslint-enable react/no-unused-prop-types */

PopupQuestion.defaultProps = {
    isHidden: false,
    onResponseSelected: () => {},
    onHide: () => {},
    selectedResponse: undefined,
};

export default PopupQuestion;
